module.exports = __webpack_public_path__ + "static/media/redemption-gift-towel.4fa2988e.png";